import React from "react";
import { Content } from "../pages/Template";
import styled from "styled-components";
import { device } from "../helpers/style";

const Container = styled.div`
    margin: 30px auto 0 auto;
    padding: 0 20px;
    width: 500px;
    color: #000;
    text-align: center;

    @media ${device.phone} {
        width: 100%;
    }
`;

const Heading = styled.div`
    margin-bottom: 30px;
    font-size: 24px;
`;
const Text = styled.div`
    margin-bottom: 30px;
    line-height: 24px;
    font-size: 18px;

    span {
        margin: 0 10px;
    }
`;

export class CopyrightsPage extends React.Component {
    static paths = ["/app/copyrights"];

    render() {
        return (
            <Content>
                <Container>
                    <Heading>کاپی رائٹ</Heading>
                    <Text>
                        اشاعت کے تمام حقوق
                        <span dir="ltr">urdupub.com</span>
                        کے ذریعہ محفوظ ہیں. مناسب رضامندی کے بغیر دوبارہ اشاعت
                        کرنے کی اجازت نہیں ہے.
                    </Text>
                    <Text dir="ltr">
                        All rights of the publication are reserved by
                        UrduPub.com. Reproduction without proper consent is not
                        allowed.
                    </Text>
                </Container>
            </Content>
        );
    }
}
